import { buttonProxy } from './button.proxy';

export function marketPropositionproxy(component: any): any {
    const componentType = component?.fields?.componentType;
    const entries = component?.fields?.entries[0];
    const title = entries?.fields?.title;
    const bannerComponentType = entries?.fields?.componentType;
    const description = entries?.fields?.description;
    const hyperLinkText = entries?.fields?.hyperLinkText;


    // Safely handle the actions and cards arrays
    const buttons = Array.isArray(entries?.fields?.actions) ? entries.fields.actions.map((action: any) => {
        return buttonProxy({
            ...action.fields
        });
    }) : [];


    const cards = Array.isArray(entries?.fields?.cards) ? entries.fields.cards.map((card: any) => {
        return {
            cardTitle: card?.fields?.title ?? '',
            cardHeader: card?.fields?.header ?? '',
            cardDescription: card?.fields?.description
        };
    }) : [];


    return {
        componentType,
        title,
        description,
        hyperLinkText,
        buttons,
        cards,
        bannerComponentType
    };
}
